import getConfig from 'next/config';
const { API_HOST, API_VERSION } = getConfig().publicRuntimeConfig;

const baseUrl = `${API_HOST}/${API_VERSION}`;

export const getUrl = (apiStr: string) => `${baseUrl}${apiStr}`;

export enum Methods {
  POST = 'POST',
  GET = 'GET',
}
